// extracted by mini-css-extract-plugin
module.exports = {"toggle":"toggleButton_toggle__3eW2O","checkbox":"toggleButton_checkbox__1fg5I"};